import { z } from "zod"

import { PriceChangeType } from "@/graphql/codegen/graphql"

export const PriceChangeFormSchema = z.object({
  changeType: z.nativeEnum(PriceChangeType, {
    required_error: "Change Type is required",
  }),
  supplierId: z.string().optional(),
  customerIds: z.array(z.string()).optional(),
  productCategoryId: z.string().optional(),
  productClassId: z.string().optional(),
  specificProductIds: z.array(z.string()).optional(),
  shipFrom: z.string().optional(),
  shipTo: z.string().optional(),
  effectiveDate: z.string().nullable().optional(),
})

export type PriceChangeFormValues = z.infer<typeof PriceChangeFormSchema>
